import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import api, { apiError } from "../lib/api";
import { toast } from "sonner";
import { KeyRound, Loader2 } from "lucide-react";

export default function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.post("/auth/forgot-password", { email });
      setResult(r.data);
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#fafcfa]">
      <Header />
      <main className="flex-1 flex items-center justify-center px-4 py-16">
        <div className="w-full max-w-md bg-white rounded-lg border border-[#e2ebe4] p-8" data-testid="forgot-password-page">
          <KeyRound className="w-8 h-8 text-[#009900] mb-3" />
          <h1 className="heading-upper text-xl text-[#144733]">{t("Reset your password.")}</h1>
          <p className="text-xs text-[#57685e] mt-1">{t("Enter the email on your account and we'll issue a reset link.")}</p>
          {result ? (
            <div className="mt-6 bg-[#f0f9f0] border border-[#009900]/25 rounded-lg p-4 text-sm text-[#144733]" data-testid="forgot-result">
              <p>{result.message}</p>
              <p className="mt-3 text-xs">
                <span className="bg-[#FFDC00] text-[#0F1E17] font-bold px-1.5 py-0.5 rounded text-[9px] uppercase mr-1">{t("Demo")}</span>
                {t("Email sending is mocked — the reset email is delivered to the admin Outbox (Account → Outbox).")}
              </p>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-6 space-y-4">
              <div>
                <label className="field-label">{t("Email")}</label>
                <input type="email" required className="field-input" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" />
              </div>
              <button type="submit" disabled={busy} className="btn-cta rounded w-full py-3 text-xs flex items-center justify-center gap-2 disabled:opacity-50" data-testid="forgot-submit-btn">
                {busy && <Loader2 className="w-4 h-4 animate-spin" />} {t("Issue reset link")}
              </button>
            </form>
          )}
          <p className="text-xs text-[#57685e] mt-6">{t("Remembered it?")} <Link to="/login" className="text-[#009900] underline">{t("Back to sign in")}</Link></p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
